module.exports = __webpack_public_path__ + "static/media/landingService1.cf9115e8.png";